import React, {useEffect} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {resetAppData} from "../../helpers";
import "../../assets/styles/auth/login.scss";
import {useAppSelector} from "../../store/store";
import {apiLogout} from "../../api/appApi";
import {appForceLogout} from "../../store/actions/appAction";

export default function Logout() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const store = useAppSelector((state) => state);
    const token = store?.userReducer?.user?.token;
    const businessToken = store?.businessReducer?.business?.token;

    useEffect(() => {
        dispatch(apiLogout(token, businessToken))
        dispatch(appForceLogout(false))
        resetAppData(dispatch);
        navigate("/auth/login");
    }, []);

    return null;
}
